import { render, staticRenderFns } from "./OrganismConfigurationComparison.vue?vue&type=template&id=1b9bdf38&scoped=true&"
import script from "./OrganismConfigurationComparison.vue?vue&type=script&lang=js&"
export * from "./OrganismConfigurationComparison.vue?vue&type=script&lang=js&"
import style0 from "./OrganismConfigurationComparison.vue?vue&type=style&index=0&id=1b9bdf38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bdf38",
  null
  
)

export default component.exports